import { useEffect, useMemo, useState } from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import app from "./firebase";
import { useNavigate } from "react-router-dom";
import styles from "./ProductionHistoryDashboard.module.css";

const db = getFirestore(app);

export default function ProductionHistoryDashboard() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const snap = await getDocs(collection(db, "products"));
        const rows = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setProducts(rows);
      } catch (err) {
        console.error("Error fetching products:", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) return products;
    return products.filter(p => (p.name || "").toLowerCase().includes(term));
  }, [products, search]);

  if (loading) return <p className={styles.loading}>Loading production history...</p>;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Production History</h2>
      </div>

      <div className={styles.controls}>
        <input
          className={styles.searchInput}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search products..."
        />
      </div>

      <div className={styles.list}>
        {filtered.map(p => (
          <button
            key={p.id}
            className={styles.productRow}
            onClick={() => navigate(`/production-history/${p.id}`)}
            title="View batches"
          >
            <span className={styles.productName}>{p.name || "(Unnamed product)"}</span>
            <span className={styles.chevron}>→</span>
          </button>
        ))}
        {filtered.length === 0 && <div className={styles.empty}>No products found</div>}
      </div>
    </div>
  );
}
